import { http } from '@/lib/http';
import { createHttpClient, postSearchCode as postSearchCodeCommon } from '@monorepo/common';

export type { PostSearchCodeResponse } from '@monorepo/common';

export const postSearchCode = async (serialCode: string) => {
  const httpClient = createHttpClient(http);
  return await postSearchCodeCommon(serialCode, process.env.NEXT_PUBLIC_SERVICE_ID!, httpClient);
};
